export default __webpack_public_path__ + "static/media/rambouillet11.f24c8aa1.jpg";